import { mat4, vec3 } from "gl-matrix";
import { unproject, Ray, toRadian } from "@spi/Common/Math";
import { ViewPort } from "./ViewPort";

export abstract class Camera {

    protected invalidatedModelView: boolean;
    protected invalidatedProjection: boolean;

    protected _modelViewMatrix: mat4;
    protected _projectionMatrix: mat4;

    public get modelViewMatrix(): mat4 {
        if (this.invalidatedModelView) {
            this.applyModelView(this._modelViewMatrix);
            this.invalidatedModelView = false;
        }
        return this._modelViewMatrix;
    }

    public get projectionMatrix(): mat4 {
        if (this.invalidatedProjection) {
            this.applyPerspective(this._projectionMatrix);
            this.invalidatedProjection = false;
        }
        return this._projectionMatrix;
    }

    constructor(public viewPort: ViewPort) {
        this._modelViewMatrix = mat4.identity(mat4.create());
        this._projectionMatrix = mat4.create();

        this.invalidatedModelView = true;
        this.invalidatedProjection = true;
    }

    getRay(x: number, y: number): Ray {

        let near = unproject(
            vec3.fromValues(x, y, 0),
            this.projectionMatrix,
            this.modelViewMatrix,
            this.viewPort);

        let far = unproject(
            vec3.fromValues(x, y, 1),
            this.projectionMatrix,
            this.modelViewMatrix,
            this.viewPort);

        return new Ray(
            vec3.fromValues(near[0], near[1], near[2]),
            vec3.fromValues(far[0], far[1], far[2])
        );
    }

    protected applyPerspective(matrix: mat4): void {
        mat4.perspective(matrix, toRadian(45), this.viewPort.aspectRatio, 0.1, 10000.0);
    }
    protected applyOrtho(matrix: mat4) {
        mat4.ortho(matrix, -this.viewPort.width / 2, this.viewPort.width / 2, -this.viewPort.height / 2, this.viewPort.height / 2, -1.0, 10000.0);
    }

    protected abstract applyModelView(matrix: mat4): void;

    public abstract get position() : vec3 | number[];

    public abstract prepareFrame(): void;
}